import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "../../src/components/Student/StuStyles/TrainingPrograms.css";
import ApiService from "../nhrc_apis/ApiService";

// fallback image if backend doesn't send one / image fails to load
import img1 from "../assets/stu-live-event1.png";

const ITEMS_PER_PAGE = 3;

const Hrlivetraining = () => {
  const navigate = useNavigate();

  const [trainings, setTrainings] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);

  useEffect(() => {
    fetchHrTrainings();
  }, []);

  const fetchHrTrainings = async () => {
    try {
      setLoading(true);

      const response = await ApiService.TrainingAPI.getHrTrainings();

      console.log("HR TRAININGS RESPONSE:", response.data);

      setTrainings(response.data || []);
      setCurrentPage(1); // reset to first page on fresh fetch
    } catch (error) {
      console.error("ERROR FETCHING HR TRAININGS:", error);
      setTrainings([]);
    } finally {
      setLoading(false);
    }
  };

  // ===============================
  // SAFE FIELD MAPPING
  // (backend key names may differ — adjust these once you confirm the real response shape)
  // ===============================
  const getTitle = (item) =>
    item.title || item.training_name || item.name || "Untitled Training";

  const getCategory = (item) =>
    item.category || item.program_category || "N/A";

  const getTrainer = (item) =>
    item.trainer || item.trainer_name || item.host || "N/A";

  const getMode = (item) =>
    item.eventmode || item.mode || item.training_mode || "N/A";

  const getSchedule = (item) =>
    item.schedule ||
    (item.start_date && item.end_date
      ? `${item.start_date} - ${item.end_date}`
      : item.start_date || "N/A");

  const getTime = (item) => item.time || item.training_time || "N/A";

  const getLocation = (item) => item.location || "N/A";

  const getImage = (item) => item.image_url || item.image || img1;

  const getId = (item) => item.id || item.training_id;

  const handleApply = (program) => {
    navigate("/hrdashboard/Hrtrainapplication", { state: program });
  };

  // ===============================
  // PAGINATION LOGIC
  // ===============================
  const totalPages = Math.ceil(trainings.length / ITEMS_PER_PAGE);

  const startIndex = (currentPage - 1) * ITEMS_PER_PAGE;
  const currentTrainings = trainings.slice(
    startIndex,
    startIndex + ITEMS_PER_PAGE
  );

  const handlePrevious = () => {
    setCurrentPage((prev) => Math.max(prev - 1, 1));
  };

  const handleNext = () => {
    setCurrentPage((prev) => Math.min(prev + 1, totalPages));
  };

  return (
    <div className="stu-live-container">
      <h2 className="stu-live-title">Live Training Program</h2>

      <div className="stu-live-wrapper">
        {loading ? (
          <h3 style={{ textAlign: "center", padding: "20px" }}>
            Loading trainings...
          </h3>
        ) : trainings.length === 0 ? (
          <h3 style={{ textAlign: "center", padding: "20px" }}>
            No training programs found
          </h3>
        ) : (
          currentTrainings.map((item, index) => (
            <div className="stu-live-card" key={getId(item) || index}>
              <div className="stu-live-left">
                <h3 className="stu-live-heading">{getTitle(item)}</h3>

                <p className="stu-live-company">
                  Program Category : <span>{getCategory(item)}</span>
                </p>

                <p className="stu-live-text">
                  Trainer/Host : {getTrainer(item)}
                </p>
                <p className="stu-live-text">
                  Training Mode: {getMode(item)}
                </p>

                <p className="stu-live-text">
                  Schedule :{" "}
                  <span className="stu-age">{getSchedule(item)}</span>
                </p>
                <p className="stu-live-text">
                  Time : <span className="stu-age">{getTime(item)}</span>
                </p>
                <p className="stu-live-text">
                  Location :{" "}
                  <span className="stu-age">{getLocation(item)}</span>
                </p>

                <p className="stu-live-seats">Limited Seats Available!</p>

                <button
                  className="stu-live-btn"
                  onClick={() => handleApply(item)}
                >
                  REGISTER NOW
                </button>
              </div>

              <div className="stu-live-right">
                <img
                  src={getImage(item)}
                  alt="program"
                  className="stu-live-img"
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = img1;
                  }}
                />
              </div>
            </div>
          ))
        )}
      </div>

      {/* ============================
          PAGINATION CONTROLS
      ============================ */}
      {!loading && trainings.length > 0 && (
        <div
          className="stu-live-pagination"
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: "16px",
            marginTop: "24px",
          }}
        >
          <button
            className="stu-live-btn"
            onClick={handlePrevious}
            disabled={currentPage === 1}
            style={{
              opacity: currentPage === 1 ? 0.5 : 1,
              cursor: currentPage === 1 ? "not-allowed" : "pointer",
            }}
          >
            Previous
          </button>

          <span>
            Page {currentPage} of {totalPages}
          </span>

          <button
            className="stu-live-btn"
            onClick={handleNext}
            disabled={currentPage === totalPages}
            style={{
              opacity: currentPage === totalPages ? 0.5 : 1,
              cursor:
                currentPage === totalPages ? "not-allowed" : "pointer",
            }}
          >
            Next
          </button>
        </div>
      )}
    </div>
  );
};

export default Hrlivetraining;